<template>
  <div class="privacy">
    <header-top :headerPosition="false">
      <div slot="title">新用户引导奖励规则</div>
    </header-top>
    <div class="privacy-wrapper">
      <div class="privacy-content">
        1、若对方在与你的私聊界面中完成任意充值，你将得到{{
          integral
        }}积分基础奖励，并且获得对方充值金额的{{ additional }}%的额外奖励，所有奖励实时到账；<br />
        2、收到系统提示消息的{{ time }}小时内，对方的首次充值才可获
        得奖励，超出时间或超出充值次数均无奖励；<br />
        3、只有新用户主动发起消息，并且系统提示有奖励的对话 才有此奖励；<br />
        4、为顺利引导新用户，他发送的前{{ num }}条消息免费且没有收益；
        <br />5、可获得奖励的充值入口如下：<br />
        a.与你的私聊礼物面板、语音礼物面板、视频礼物面板中的“充值”按钮；<br />
        b.与你的私聊礼物面板、语音礼物面板、视频礼物面板中的充值礼包；<br />
        c.与你发消息&送礼余额不足充值弹窗、语音/视频余额不足充值弹窗；
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.tab1 {
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  color: #9a9eb9;
  text-align: center;
  border-color: #eee;
  tr {
    font-size: 16px;
  }
  .tr1 {
    width: 100px;
  }
  .tr2 {
    min-width: 40px;
  }
  .tr3 {
    width: 80px;
  }
  .tr4 {
    width: 100px;
  }
  .tr5 {
    max-width: 350px;
    word-break: break-all;
  }
}
.thead {
  color: #3f446f;
  font-size: 24px;
  line-height: 30px;
  margin-top: 7px;
  text-align: center;
}
.privacy {
  background-color: #f6f5fb;
}
.privacy-wrapper {
  padding-top: 120px;
  padding: 120px 30px 0 30px;
  width: 690px;
  text-align: left;
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: #3f446f;
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
  .phone {
    text-decoration: underline;
  }
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";
import { getUrlParams } from "src/utils/tool";

const { mm } = window;
export default {
  name: "Privacy",
  data() {
    return {
      IOSUser: false,
      appName: this.$store.state.appName,
      integral: getUrlParams("integral") || 10,
      additional: getUrlParams("additional") || 10,
      time: getUrlParams("time") || 12,
      num: getUrlParams("num") || 5
    };
  },
  mounted() {},
  components: {
    "header-top": HeaderTop // 顶部导航组件
  },
  created() {
    console.log("appName:", this.appName);
    const iOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (iOS) {
      this.IOSUser = iOS;
      // console.log("iOS终端", iOS);
    }
  },
  methods: {
    callServe(phone) {
      mm.ui.openUrl({
        target: 3,
        url: ` goto://MultiFunction_Action_Protocol?action=dail&content=${phone}`
      });
    },
    gotoPage() {
      this.$router.push({
        name: "empower"
      });
    }
  }
};
</script>
